import React from 'react'
import { useTranslation } from 'react-i18next'

import Close from '../../../components/shared/icons/Close'
import { FilterForm } from '../../../components/DataTable/components'
import Button from 'components/Button'
import FilterComponent from '../fragments/FilterComponent'

const withFilterSideList = WrappedComponent => {
	const FilterSideListWrap = ({ isFiltered, clearFilter, toggleFilterWindow, showFilter, filterValues, setFilter, ...props }) => {
		const [t] = useTranslation()

		const FilterBtn = (
			<>
				{!!isFiltered && <Close onClick={clearFilter}/>}
				<Button status='dropdown' text={t('common.buttons.filter')} onClick={toggleFilterWindow}/>
			</>
		)

		let FilterWindow = null
		if(showFilter) {
			FilterWindow = (
				<>
					<FilterForm
						withButtons={true}
						filterValues={filterValues}
						setFilter={setFilter}
						clearFilter={clearFilter}
						toggleFilterWindow={toggleFilterWindow}
						FilterComponent={FilterComponent}
					/>
				</>
			)
		}

		return(
			<WrappedComponent
				{...props}
				filterValues={filterValues}
				FilterBtn={FilterBtn}
				FilterWindow={FilterWindow}
			/>
		)
	}

	return FilterSideListWrap
}

export default withFilterSideList
